import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { getStatusId, STATUS } from '@btime/constants'
import { useServiceOrderContextEvents } from '../ServiceOrderContextEvents'
import { formatApiDate } from '../../../../utils/helpers/date'

const MUTATION = gql`
  mutation UpdateServiceOrder($input: ServiceOrderInput, $token: String, $id: Int) {
    updateServiceOrder(id: $id, input: $input, token: $token) {
      id
    }
  }
`
const useCompleteServiceOrder = () => {
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['ServiceOrders', 'ServiceOrdersCount', 'ServiceOrder', 'Events'],
    client: serviceOrdersClient
  })
  const notify = useNotification()
  const modal = useAlert()
  const { events } = useServiceOrderContextEvents()

  const handleRequest = item => {
    if (!modal.confirm({ title: 'Tem certeza que deseja concluir a atividade?' })) return false

    const eventsToAdd = []

    const atLeastOneCompleteEvent = events.current?.find(event => event.status.id === getStatusId(STATUS.COMPLETED))
    if (!atLeastOneCompleteEvent) {
      eventsToAdd.push({ statusId: getStatusId(STATUS.COMPLETED), eventDate: formatApiDate(new Date()) })
    }
    return request({
      variables: { id: item.id, input: { events: eventsToAdd, statusId: getStatusId(STATUS.COMPLETED) } }
    }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: 'Atividade concluída com sucesso!' })
      } else {
        notify.error({ title: 'Ocorreu um erro ao concluir a atividade!' })
      }
    })
  }

  return [handleRequest, state]
}

export default useCompleteServiceOrder
